<template>
  <div class="AudioTest" @click="toggleAudioTestDialogue()">
    <div class="at-container" @click="$event.stopPropagation()">
      <h1 class="at-title">{{ $t('Audiotest') }}</h1>
      <p style="font-size: 16px; text-align: center;">
        {{ $t('Der Audiotest simuliert eine Verbindung zum Server. Sie können ihre Audioübertragung dann abhören, um sie zu überprüfen.') }}
      </p>

      <div class="at-content-container">

        <transition name="fade">
          <div class="at-content" v-if="!stateOfEchoTest">
            <div class="at-loading">
              <div class="flux-animation-circle-one flux-animation-circle"></div>
              <div class="flux-animation-circle-two flux-animation-circle"></div>
              <div class="flux-animation-circle-three flux-animation-circle"></div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div class="at-content at-success" v-if="stateOfEchoTest == 'finished'">
            <md-button class="normal-md-button at-success-muteButton" @click="toggleAudio()">
              <VolumeOn v-if="audioOn"/>
              <VolumeOff v-else/>
            </md-button>
            <meter class="at-audioMeter" high="0.8" low="0.1" optimum="0.5" value="0" min="0" max="1"/>
          </div>
        </transition>

        <transition name="fade">
          <div class="at-content at-failed" v-if="stateOfEchoTest == 'failed'">
            <p>{{ $t('Verbindung zum Server fehlgeschlagen!') }}</p>
            <md-button style="margin-bottom: 10px;" class="normal-md-button" @click="repeatTest()">
              {{ $t('Wiederholen') }}
            </md-button>
          </div>
        </transition>

      </div>
     
      
      <md-button class="normal-md-button" @click="toggleAudioTestDialogue()">{{ $t('Zurück') }}</md-button>

      <!-- Needed for subscriber/pusblisher (divs are hidden) -->
      <div style="display:none;" id="subscriber-echo-test"/>
      <div style="display:none;" id="publisher-echo-test"/>
    </div>
  </div>
</template>

<style scoped>
.AudioTest{
  width: 100%;
  height: 100%; 
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9;
  background: #000000e3;
}
.at-container{
  z-index: 10;
  padding: 25px;
  color: rgb(37, 37, 37);
  background: white;
  border-radius: 10px;
  width: 600px;
}
.at-title{
  text-align: center;
  margin: 10px 0 30px 0;
}
.at-content-container{
  height: 130px;
  position: relative;
}
.at-content{
  text-align: center;
  position: absolute !important;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}
.at-success{
  text-align: center;
}
.at-success-muteButton{
  margin: 30px;
  margin-bottom: 5px;
}
.at-audioMeter{
  margin-top: 10px;
  min-height: 10px;
  width: 80%;
}
.at-loading {
  position: relative;
  width: 70px;
  height: 70px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
}
.flux-animation-circle {
  position: absolute;
  background-color: var(--primaryColor);
  width: 12px;
  height: 12px;
  border-radius: 100%;
}
.flux-animation-circle-one {
  animation: fly-one 1.1s infinite ease-in-out;
  left: calc(100% - 4px);
  top: 33.3%;
}
.flux-animation-circle-two {
  animation: fly-two 1.1s infinite ease-in-out;
  left: 4px;
  top: 66.6%;
}
.flux-animation-circle-three {
  animation: fly-three 1.1s infinite ease-in-out;
  left: 4px;
  top: calc(33.3% - 2px);
}
@keyframes fly-one {
  0% {
    left: calc(100% - 4px);
    top: 33.3%;
  }
  18% {
    left: calc(50% - 2px);
    top: 4px;
  }
  40% {
    left: 4px;
    top: calc(33.3% - 2px);
  }
  49.9% {
    left: 4px;
    top: calc(66.6% - 2px);
  }
  66.6% {
    left: calc(50% - 2px);
    top: calc(100% - 2px);
  }
  81% {
    left: calc(100% - 4px);
    top: 66.6%;
  }
  100% {
    left: calc(100% - 4px);
    top: 33.3%;
  }
}
@keyframes fly-two {
  0% {
    left: calc(50% - 2px);
    top: 4px;
  }
  25% {
    left: 4px;
    top: calc(33.3% - 2px);
  }
  33.3% {
    left: 4px;
    top: calc(66.6% - 2px);
  }
  49.9% {
    left: calc(50% - 2px);
    top: calc(100% - 2px);
  }
  63% {
    left: calc(100% - 4px);
    top: 66.6%;
  }
  75% {
    left: calc(100% - 4px);
    top: 33.3%;
  }
  100% {
    left: calc(50% - 2px);
    top: 4px;
  }
}
@keyframes fly-three {
  0% {
    left: 4px;
    top: calc(33.3% - 2px);
  }
  16.6% {
    left: 4px;
    top: calc(66.6% - 2px);
  }
  33.3% {
    left: calc(50% - 2px);
    top: calc(100% - 2px);
  }
  45% {
    left: calc(100% - 4px);
    top: 66.6%;
  }
  57% {
    left: calc(100% - 4px);
    top: 33.3%;
  }
  74% {
    left: calc(50% - 2px);
    top: 4px;
  }
  100% {
    left: 4px;
    top: calc(33.3% - 2px);
  }
}

@media screen and (max-width: 900px) {
  .at-container{
    width: 90%;
  }
}
</style>

<script>

import {mapGetters} from 'vuex'

import * as RaumtaenzerApi from "@/api/raumtaenzer";
import OT from "@opentok/client";

// Icons
import VolumeOn from 'vue-material-design-icons/VolumeHigh.vue'
import VolumeOff from 'vue-material-design-icons/VolumeOff.vue'


const publisherDefaultBackground = require("@/assets/black_background_for_publisher.png");
const NetworkTest = require('opentok-network-test-js').default;

export default {
  components: {VolumeOn,VolumeOff},
  data: () => ({
    session: null,
    publisher: null,
    subscriber: null,
    echoTestSuccessful: false,
    stateOfEchoTest: null,
    audioOn: false,
  }),
  props: {
    setEchoTestState: Function,
    toggleAudioTestDialogue: Function,
  },
  computed: {
    ...mapGetters(['getAudioDeviceId', 'localUser']),
  },
  mounted() {
    console.log("AudioTest: starting")  
    this.runTests();
  },
  destroyed(){
    console.log("AudioTest: cleaning up")
    this.cleanUp();
  },
  methods: {
    repeatTest(){
      this.stateOfEchoTest = null;
      this.cleanUp();
      this.runTests();
    },
    toggleAudio(){
      this.audioOn = !this.audioOn;
      this.subscriber.setAudioVolume(this.audioOn ? 1000 : 0);
    },
    runTests() {
      this.echoTest();
    },
    async echoTest(){
      let self = this;
      this.initializePublisher().then((publisher) => {
        this.initializeSession().then((session) => {
          self.session = session;
          self.publisher = self.session.publish(publisher, (error) => {
            if (error) {
              console.error(error);
              self.stateOfEchoTest = "failed";
            } else {
              console.log("Echo Test: Publisher published");
              this.initializeSubscriber(self.publisher, self.session).then((subscriber) => {
                self.subscriber = subscriber;
                self.stateOfEchoTest = "finished"; 
                self.subscriber.on('audioLevelUpdated', function(event){
                  // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
                  let logLevel = (Math.log(event.audioLevel) / Math.LN10) / 1.5 + 1;
                  logLevel = Math.min(Math.max(logLevel, 0), 1) + 1;
                  document.getElementsByClassName("at-audioMeter")[0].value = logLevel-1;
                });
              }).catch(function (e) {
                console.error(e);
              })
            }
          });
        }).catch(function (e) {
          self.stateOfEchoTest = "failed";
          console.error(e);
        })
      }).catch(function (e) {
        self.stateOfEchoTest = "failed";
        console.error(e);
      })
    },
    cleanUp(){
      if(this.session){
        this.session.unsubscribe(this.subscriber);
        this.session.unpublish(this.publisher);
      }
      if(this.publisher)
        this.publisher.destroy();

      if(this.session)
        this.session.disconnect();
    },
    initializePublisher: async function(){
      const self = this;
      return new Promise((resolve) => {
        const options = {
          videoSource: null,
          audioSource: this.getAudioDeviceId,
        }
        let publisher = OT.initPublisher("publisher-echo-test", options, (error) => {
          if (error) {
            console.log(error);
            self.stateOfEchoTest = "failed";
          } else {
            console.log("Echo Test: Publisher completed");
            resolve(publisher);
          }
        });
      })
    },
    initializeSubscriber: async function(publisher, session) {
      const self = this;
      return new Promise((resolve) => {
        const subscriberOptions = {
          style: {
            audioLevelDisplayMode: 'auto',
            backgroundImageURI: publisherDefaultBackground,
            nameDisplayMode: 'auto',
            disableAudioProcessing: true,
            autoGainControl: false,
            echoCancellation: false,
            enableStereo: false,
          },
          // testNetwork: Whether, when subscribing to a stream published by the local client, you want to have the stream
          // come from the OpenTok Media Router (true) or if you want the DOM to simply to display the local
          // camera's video (false). Set this to true when you want to use the Subscriber.getStats() method to
          // check statistics for a stream you publish. This setting only applies to streams published by the
          // local client in a session that uses the OpenTok Media Router (sessions with the media mode set
          // to routed), not in sessions with the media mode set to relayed. The default value is false.
          testNetwork: true,
        }
        let subscriber = session.subscribe(
            publisher.stream,
            "subscriber-echo-test",
            subscriberOptions,
            error => {
              if (error) {
                console.error(error);
                self.stateOfEchoTest = "failed";
              } else {
                console.log("Echo Test: subscribed to stream");
                resolve(subscriber);
              }
            })
      })
    },
    initializeSession: async function(){
      const self = this;
      return new Promise(resolve => {
        const data = {
          user_id: this.localUser.id,
          user_name: this.localUser.getName(),
          role: this.localUser.getRole(),
          room_id: this.localUser.id + "_test"
        };
        const accessToken = "test";
        RaumtaenzerApi.getVideoSessionInfoForRoom(accessToken, data).then((result) => {
          const openTokSessionInfo = {
            apiKey: result.api_key,
            sessionId: result.session_id,
            token: result.access_token
          }
          const session = OT.initSession(openTokSessionInfo.apiKey, openTokSessionInfo.sessionId);
          session.on({
            connectionCreated: () => {
              console.warn("connection created");
            },
            connectionDestroyed: () => {
              console.warn("connection destroyed");
            },
            sessionConnected: () => {
              console.warn("session connected");
            },
            sessionDisconnected: () => {
              console.warn("session disconnected");
            },
            sessionReconnected: () => {
              console.warn("sessionReconnected");
            },
            sessionReconnecting: () => {
              console.warn("sessionReconnecting");
            },
            streamCreated: () => {
              console.warn("streamCreated");
            },
            streamDestroyed: () => {
              console.warn("streamDestroyed");
            },
          });
          session.connect(openTokSessionInfo.token, error => {
            if (error) {
              console.error(error);
              self.stateOfEchoTest = "failed";
            } else {
              resolve(session);
            }
          })
        })
      })
    },
  },
}
</script>